import { ICPlatformVersion } from '@retailer-platform/dashboard/access-control'
import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { Permission } from './permissions'
import { FeatureEntitlements } from './featureEntitlements'

export const minWholesalerNavigationVersion = ICPlatformVersion.r2025_03_0
export const minSocialIconsAndSidebarNavigationVersion = ICPlatformVersion.r2025_04_0
export const minLanguageSelectorVersion = ICPlatformVersion.r2025_09_0
// TODO, remove once we have a store configuration for this
export const tempHideNativeNavigationPartners = [
  '1210', //Costco US
  '1178', //Costco CA
  '1235', //Costco Business US
  '1504', //Costco Business CA
  '1648', //Costco Spain
  '1654', //Costco France
  '1475', //Publix SFP
]

export const tempCostcoAllowLanguageSelector = [
  '15', // Costco
  '1017', // CostcoCanada
  '1066', // CostcoOnecart
  '1076', // CostcocaOnecart
  '1149', // CostcoBusinessCenterOnecart
  '1178', // CostcoCanadaSfx
  '1210', // CostcoSfp
  '1235', // CostcoBusinessCenterSfp
  '1504', // CostcoBusinessCanadaSfp
]

export const legacyReadOnlyAccessControl: DomainAccessControlConfig = {
  permissions: [Permission.ReadOnly],
  restrictedBannersAllowed: true,
}

export const siteManagementNavigationAccessControl = {
  featureEntitlementIds: [FeatureEntitlements.Navigation],
  permissions: [Permission.StoreConfigsView, Permission.SiteManagementStorefrontNavigationView],
  restrictedBannersAllowed: true,
} satisfies DomainAccessControlConfig

export const siteManagementNavigationModifyAccessControl = {
  featureEntitlementIds: [FeatureEntitlements.Navigation],
  permissions: [Permission.StoreConfigsModify],
  restrictedBannersAllowed: true,
} satisfies DomainAccessControlConfig
